import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {map, tap} from "rxjs/operators";
import {TransactionsV3RestService} from "../../services/rest/v3/transactions-rest.service";
import {ProductsListDataAdapter,} from "../../components/account-products/account-products.component";
import {ProductRef} from "../../model/v3/transactions";

@Component({
    selector: 'app-teachers-products-page',
    templateUrl: './teachers-products-page.component.html',
    styleUrls: ['./teachers-products-page.component.css'],
    standalone: false
})
export class TeachersProductsPageComponent implements OnInit {
  schoolId: number;
  productsAdapter: ProductsListDataAdapter;
  isTeacherSubscribed = false
  constructor(
    route: ActivatedRoute,
    private transactionsRest: TransactionsV3RestService
    ) {
    route.parent.paramMap.pipe(
      map( params => [Number(params.get("schoolId")), Number(params.get("teacherId"))]),
      tap(([schoolId, _]) => this.schoolId = schoolId),
      tap(([schoolId, teacherId]) => {
        this.productsAdapter = {
          listProducts: () => transactionsRest.getTeacherProducts(schoolId, teacherId),
          syncProducts: (products: ProductRef[]) =>
            transactionsRest.syncTeacherProducts(schoolId, teacherId, products),
        }
      }),
    ).subscribe();
  }

  ngOnInit() {
  }

}
